import React, { useEffect, useState, useCallback } from 'react'
import { Link } from 'react-router-dom'
import { Row, Col, Grid, Typography, Descriptions, Spin } from 'antd'
import useBurns from 'hooks/useBurns'
import { BurnsTable } from 'components/Tables'
import { useCentricInfo } from 'state/centric/hooks'
import { CentricItemStatus } from 'state/centric/types'
import { formatLocal } from 'utils'
import { CNR } from 'constants/tokens'

const { Title } = Typography
const { useBreakpoint } = Grid

const Burns: React.FC = () => {
  const screens = useBreakpoint()

  const [currentPage, setCurrentPage] = useState(1)
  const [maxResults] = useState(1000)
  const [querySize] = useState(200)

  const paginateChange = (page) => {
    setCurrentPage(page)
  }

  const pageSizeChange = (current) => {
    setCurrentPage(current)
  }

  const burnsCallback = useBurns(querySize, maxResults)

  const [state, setState] = useState({ loading: false, errorMessage: undefined, burns: [] })

  const fetchBurns = useCallback(() => {
    setState({ loading: true, errorMessage: undefined, burns: [] })
    burnsCallback()
      .then((burns) => {
        setState({ loading: false, errorMessage: undefined, burns })
      })
      .catch((error) => {
        setState({ loading: false, errorMessage: error.message, burns: [] })
      })
  }, [burnsCallback])

  useEffect(() => {
    if (burnsCallback) {
      fetchBurns()
    }
  }, [burnsCallback, fetchBurns])

  const { cnrBurnt, status } = useCentricInfo()

  return (
    <>
      <Row gutter={32}>
        <Col span={24}>
          <Title level={2}>Protocol Burn History</Title>
        </Col>
      </Row>
      <Row gutter={32} style={{ marginTop: '1.5rem' }}>
        <Col xs={24} md={12}>
          <Descriptions layout="horizontal" column={1} colon bordered size={screens.lg ? 'middle' : 'small'}>
            <Descriptions.Item label="Total Burn" span={1}>
              {status === CentricItemStatus.FINISHED ? (
                <>
                  {formatLocal(cnrBurnt, 2)} <Link to="/tokens/cnr">{CNR.symbol}</Link>
                </>
              ) : status === CentricItemStatus.ERROR ? (
                'Error'
              ) : (
                <Spin size="small" />
              )}
            </Descriptions.Item>
          </Descriptions>
        </Col>
      </Row>
      <Row gutter={32} style={{ marginTop: '1.5rem' }}>
        <Col span={24}>
          <BurnsTable
            loading={state.loading}
            data={state.burns}
            errorMessage={state.errorMessage}
            currentPage={currentPage}
            currentPageSize={querySize}
            paginateChange={paginateChange}
            pageSizeChange={pageSizeChange}
            tableSize={screens.lg ? 'default' : 'small'}
          />
        </Col>
      </Row>
    </>
  )
}

export default Burns
